import React, { memo } from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  icon: {
    width: '5rem',
    height: '4.6875rem',
    animation: '$spinner 1s linear infinite',
  },
  '@keyframes spinner': {
    from: {
      transform: 'rotate(0deg)',
    },
    to: {
      transform: 'rotate(360deg)',
    },
  },
});

const Spinner = () => {
  const classes = useStyles();
  return (
    <SvgIcon className={classes.icon} viewBox="0 0 80 80" fill="none">
      <path
        d="M76 40C78.2091 40 80.0207 38.2047 79.8002 36.0066C79.2217 30.2411 77.3955 24.6532 74.4297 19.6383C70.7831 13.4724 65.5476 8.39881 59.2701 4.94773C52.9927 1.49666 45.9036 -0.205275 38.7436 0.0197375C31.5835 0.24475 24.6153 2.38845 18.5669 6.22688C12.5185 10.0653 7.61193 15.4576 4.35974 21.8404C1.10755 28.2232 -0.370872 35.3622 0.0789305 42.5116C0.528733 49.661 2.89026 56.5585 6.91677 62.4833C10.1916 67.3021 14.4701 71.3337 19.4406 74.312C21.3356 75.4474 23.7313 74.5727 24.6719 72.5738C25.6125 70.5749 24.7374 68.2123 22.8714 67.0298C19.1847 64.6936 16.0025 61.6198 13.5334 57.9867C10.3122 53.2468 8.42299 47.7288 8.06314 42.0093C7.7033 36.2898 8.88604 30.5785 11.4878 25.4723C14.0895 20.3661 18.0148 16.0522 22.8535 12.9815C27.6923 9.91076 33.2668 8.1958 38.9949 8.01579C44.7229 7.83578 50.3941 9.19733 55.4161 11.9582C60.4381 14.719 64.6265 18.7779 67.5437 23.7107C69.7798 27.4917 71.2062 31.6798 71.7503 36.0103C72.0258 38.2022 73.7909 40 76 40Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="77.3333"
          y1="37.3333"
          x2="64"
          y2="83.3333"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DC0032" />
          <stop offset="1" stopColor="#C4C4C4" stopOpacity="0" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};

export default memo(Spinner);
